import Vue from "vue";

// GLOBAL CONSTANTS
import constants from "@/constants";

// DEFAULT FEATURE FLAGS
// import features from "@/features";

// SUBSCRIPTION OBJECTS
// import subscription from "@/subscription";

import eventbus from "@/event-bus";

// DEPENDENCIES
import axios from "./setup/axios-setup";

// UTILITIES

export default Vue.observable({
  axios,
  constants,
  envs: process.env,
  developing: process.env.NODE_ENV === "development",
  // features,
  // subscription,
  eventbus
});
